export class Actual {
    private value: number;

    constructor(value: number) {
        this.value = value;
    }

    getValue() {
        return this.value;
    }

    setValue(value: number) {
        this.value = value;
    }
}